import { FULL_COMPANY_NAME } from './branding';

const pageTitleConstants = {
  suffix: `| ${FULL_COMPANY_NAME}`,
  landing: `${FULL_COMPANY_NAME} | Apply Now`,
  default: `${FULL_COMPANY_NAME}`,
};

export default pageTitleConstants;
